import { mapGetters } from 'vuex'

export default {
  computed: {

    timeRange () {
      return this.$store.getters['params/timeRange']
    },
  },

  watch: {
    timeRange() {
      this.update()
    },
  }
}
